import dayjs from 'dayjs'
import { create } from 'zustand'

type ScheduleFilters = {
  startAt: string
  endAt: string
  showItems: 'all' | 'active'

  nextMonth: () => void
  prevMonth: () => void
  goToMonth: (date: string) => void
  setStartAt: (startAt: string) => void
  setEndAt: (endAt: string) => void
  setShowItems: (showItems: 'all' | 'active') => void
}

export const useSchedulerFilters = create<ScheduleFilters>((set, get) => ({
  startAt: dayjs().startOf('month').format('YYYY-MM-DD'),
  endAt: dayjs().endOf('month').format('YYYY-MM-DD'),
  showItems: 'active',

  nextMonth: () => {
    const nextStart = dayjs(get().startAt)
      .add(1, 'month')
      .startOf('month')
      .format('YYYY-MM-DD')

    set({
      startAt: nextStart,
      endAt: dayjs(nextStart).endOf('month').format('YYYY-MM-DD'),
    })
  },
  prevMonth: () => {
    const prevStart = dayjs(get().startAt)
      .subtract(1, 'month')
      .startOf('month')
      .format('YYYY-MM-DD')

    set({
      startAt: prevStart,
      endAt: dayjs(prevStart).endOf('month').format('YYYY-MM-DD'),
    })
  },

  goToMonth: (date: string) => {
    const prevStart = dayjs(date).startOf('month').format('YYYY-MM-DD')

    set({
      startAt: prevStart,
      endAt: dayjs(prevStart).endOf('month').format('YYYY-MM-DD'),
    })
  },

  setStartAt: (startAt) => set({ startAt }),
  setEndAt: (endAt) => set({ endAt }),
  setShowItems: (showItems) => set({ showItems }),
}))
